// extracted by mini-css-extract-plugin
export var avatarContainer = "_cm-0";
export var gray = "_cm-f";
export var green = "_cm-c";
export var icon = "_cm-9";
export var image = "_cm-1";
export var lg = "_cm-6";
export var md = "_cm-5";
export var presenceDot = "_cm-b";
export var red = "_cm-d";
export var sm = "_cm-4";
export var status = "_cm-a";
export var xl = "_cm-7";
export var xs = "_cm-3";
export var xxl = "_cm-8";
export var xxs = "_cm-2";
export var yellow = "_cm-e";